import React from 'react'
import { ModalBottomSheet } from './ModalBottomSheet'
import { isMobile } from '../../../shared/lib/isMobile'
import { CenteredMessage } from '../../../shared/webcomponents/react-wrappers/CenteredMessage'
import { Translations } from '../../../shared/i18n/Translations'
import { PopupMessageModal } from '../../../shared/webcomponents/react-wrappers/PopupMessageModal'

type Props = {
    isOpen: boolean
    message: string
    onSubmit: () => void
    onCancel: () => void
}

export function ReAuthConfirmationModal(props: Props) {
    if (isMobile.phone()) {
        return phoneModal(props)
    }

    return tabletModal(props)
}

function phoneModal(props: Props) {
    return (
        <ModalBottomSheet open={props.isOpen} size="auto" onClose={props.onCancel}>
            <div className="AppCore__ui__ReAuthConfirmationModal__bottom-sheet">
                <div className="AppCore__ui__ReAuthConfirmationModal__bottom-sheet__header">
                    <button
                        className="AppCore__ui__ReAuthConfirmationModal__bottom-sheet__close-button"
                        aria-label="close"
                    >
                        <zaptic-icon icon-name="delete-grey-cross" onClick={props.onCancel}></zaptic-icon>
                    </button>
                    <h3 className="AppCore__ui__ReAuthConfirmationModal__bottom-sheet__heading">
                        {Translations.t('shared:Reauthentication.confirmation.confirmIdentity')}
                    </h3>
                </div>

                <div className="AppCore__ui__ReAuthConfirmationModal__bottom-sheet__content">
                    <CenteredMessage message={props.message} iconName="identity-check" />
                </div>

                <div className="AppCore__ui__ReAuthConfirmationModal__bottom-sheet__footer">
                    <zaptic-button type="primary" size="large" onClick={props.onSubmit}>
                        {Translations.t('shared:Reauthentication.confirmation.confirmIdentity')}
                    </zaptic-button>
                </div>
            </div>
        </ModalBottomSheet>
    )
}

function tabletModal(props: Props) {
    return (
        <PopupMessageModal
            isOpen={props.isOpen}
            heading={Translations.t('shared:Reauthentication.confirmation.confirmIdentity')}
            message={props.message}
            submitLabel={Translations.t('shared:Reauthentication.confirmation.confirmIdentity')}
            iconName="identity-check"
            onCancel={props.onCancel}
            onSubmit={props.onSubmit}
        />
    )
}
